import Vue from "vue";
import * as types from "../challenges/mutation-types";

const actions = {
  fetchPackages({ commit }, featured) {
    commit(types.SET_LOADED_STATUS, { key: "packagesLoaded", value: false });

    let isFeatured = "";
    let mutation = types.SET_ALL_CHALLENGE_PACKAGES;
    if (featured) {
      isFeatured = `?featured=1`;
      mutation = types.SET_CHALLENGE_PACKAGES_FOR_BUILDER;
    } else if (featured === 0) {
      isFeatured = `?featured=0`;
      mutation = types.SET_CHALLENGE_PACKAGES_FOR_BUILDER;
    }

    return Vue.axios.get(`challenge-packages${isFeatured}`).then(response => {
      commit(mutation, response.data.data);
      commit(types.SET_LOADED_STATUS, { key: "packagesLoaded", value: true });
    });
  },

  updatePackage({ dispatch, commit }, payload) {
    const { packageId, formData } = payload;

    return Vue.axios
      .post(`challenge-packages/${packageId}`, formData)
      .then(() => {
        commit(types.SET_LOADED_STATUS, {
          key: "packagesLoaded",
          value: false
        });
        dispatch("fetchPackages");
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );
      });
  },

  deletePackage({ dispatch }, packageId) {
    return Vue.axios
      .delete(`challenge-packages/${packageId}`)
      .then(() => {
        dispatch("fetchPackages");
        dispatch(
          "snackBar",
          {
            type: "is-success",
            message: "The package has been deleted."
          },
          { root: true }
        );
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );
      });
  }
};

export default actions;
